import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";

import { Theme } from "../../.themes";
import { useTheme } from "@material-ui/core";

export interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errorHeader?: string;
  errorMessage?: string;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, onClose, errorHeader, errorMessage }) => {
  // Responsive Paper style for dialog
  const theme: Theme = useTheme();

  const paperStyle: React.CSSProperties = {
    margin: 0,
    width: "100%",
    maxWidth: 400,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  };
  // Use media query to adjust maxWidth for mobile/desktop
  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  const dialogMaxWidth = isMobile ? "xs" : "sm";
  paperStyle.maxWidth = isMobile ? "95vw" : 400;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='error-dialog-title'
      fullWidth
      maxWidth={dialogMaxWidth}
      PaperProps={{ style: paperStyle }}
    >
      <Box position='relative' width='100%'>
        {/* Header with close icon, sticky for mobile */}
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          p={2}
          borderBottom={1}
          borderColor='divider'
          style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}
        >
          <Typography variant='h6' id='error-dialog-title' color='error' style={{ wordBreak: "break-word", maxWidth: "80%" }}>
            {errorHeader || "Server Error"}
          </Typography>
          <IconButton aria-label='close' onClick={onClose} size='small'>
            <CloseIcon />
          </IconButton>
        </Box>
        {/* Body with error message, scrollable if needed */}
        <Box p={3} textAlign='center' style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <Typography
            variant='body1'
            color='textPrimary'
            style={{ wordBreak: "break-word" }}
            component='div'
            dangerouslySetInnerHTML={{ __html: errorMessage || "An unexpected error occurred. Please contact customer support" }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errorHeader: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default ErrorDialog;
